    <template>
        <v-card-title>
        <v-container class="pa-12">
            <v-card class="pl-16 pr-16 pt-8 pb-16">
                <v-row>
                    <v-col cols="12" md="6" >
                        <v-row>
                            <v-col cols="12" md="12" >
                                <h3>Approver Settings</h3>
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col cols="12" md="12">
                                <span style="font-size: 18px;">Approval Menu </span><span style="color: red;">*</span>
                            </v-col>
                            <v-col cols="12" md="9" style="margin-top: -20px;">
                                <v-text-field
                                    v-model="modlue"
                                    single-line
                                    hide-details
                                    outlined
                                    dense
                                    disabled
                                    background-color="#F5F5F5"                                   
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <span style="font-size: 18px;">Approver Assignment </span>
                                <span style="color: red;">*</span>
                            </v-col>
                            </v-row>

                            <v-row v-for="(approval, index) in approvals" :key="index">
                            <v-col cols="10" md="9" style="margin-top: -20px;">
                                <v-autocomplete
                                v-model="approval.selected"
                                :items="emp_list"
                                item-text="name"
                                item-value="id"
                                outlined
                                dense
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="2" md="3" style="margin-top: -20px;">
                                <v-icon color="blue" @click="addAutocomplete">mdi-plus</v-icon>
                                <v-icon v-if="approvals.length > 1" color="red" @click="removeAutocomplete(index)">mdi-minus</v-icon>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="6" >
                        <v-row justify="end">
                            <v-col cols="auto">
                            <v-select
                                v-model="statusAM"
                                :items="statusOptions"
                                outlined
                                dense
                                style="width: 120px;"
                            ></v-select>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <br />
                <div>
                    <v-row>
                    <v-col align="center" cols="12" md="12">
                        <v-btn
                        depressed
                        width="100"
                        class="mr-5 buttonblue"
                        @click="saveItem()"
                        >
                        Save
                        </v-btn>
                        <v-btn depressed outlined width="100" @click="$router.back()">
                        Cancel
                        </v-btn>
                    </v-col>
                    </v-row>
                </div>
            </v-card>
            <SuccessDialog
            :status="dialogAdd"
            :text_color="text_color"
            :title="title"
            :message="message"
            />
    
            <SuccessDialogPush
            :status="dialogAdd"
            :text_color="text_color"
            :title="title"
            :message="message"
            :link="link"
            />
        </v-container>
        </v-card-title>
    </template>
    
    <script>
        import SuccessDialog from "@/components/cards/SuccessDialog";
        import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
        import api from "@/services/api";
        import { server } from "@/services/constants";
    
    export default {
        name: "Approver Management Setting",
        data() {
        return {
            dialogAdd: false,
            text_color: "text-h5 green--text text-center",
            title: "green",
            message: "green",
            link: "",
            emp_list: [],
            modlue:"",
            statusAM: "",
            approvals: [{ selected: null }],
            statusOptions: ['Active', 'Inactive'], 
        };
        },
        components: {
        SuccessDialog,
        SuccessDialogPush,
        },
        computed: {},
        watch: {},
        async mounted() {
        const userId = localStorage.getItem(server.USER_ID);
        if (userId && api.isLoggedIn()) {
            // this.$router.push("/");
        } else {
            this.$store.state.isLogged = false;
            this.$router.push("/login");
        }
        await this.loadEmp()
        await this.loaddata()

        this.$hideLoader();
        },
        methods: {
            async loaddata(){
                const resultData = await api.getApproverManagementByID(this.$route.params.id);
                this.modlue = resultData.data[0].module;
                this.statusAM = resultData.data[0].status;

                // แยก approvals_id จากสตริงที่คั่นด้วยจุลภาค และเก็บค่าเข้าไปใน this.approvals
                const approvals_ids = resultData.data[0].approver_id;

                if (approvals_ids) { // ถ้ามีค่า approvals_id
                this.approvals = approvals_ids
                    .split(',')  // แยก string โดยคั่นด้วยเครื่องหมายจุลภาค
                    .map(id => ({ selected: Number(id.trim()) }));  // ลบช่องว่าง และแปลงเป็น number
                } else {
                this.approvals = [{ selected: null }];  // ถ้าไม่มีค่า ให้เป็น null
                }

            },
            async loadEmp() {
                const result = await api.getAccountslist_by_ComID(
                    localStorage.getItem(server.COMPANYID)
                );

                this.emp_list = result.data;
            },
            addAutocomplete() {
                this.approvals.push({ selected: null }); // เพิ่ม Autocomplete ใหม่
            },
            removeAutocomplete(index) {
                this.approvals.splice(index, 1); // ลบ Autocomplete
            },
            async saveItem() {

                const approvals_id = this.approvals.length > 1
                ? this.approvals.map(item => item.selected).join(',')
                : this.approvals[0]?.selected || ''; // ถ้ามีแค่ 1 ตัวให้แสดงค่า id เดียว

                var dataUpdate = {
                    approver_id: approvals_id,
                    status: this.statusAM
                }

                this.$showLoader()
                const res_update = await api.updateApproverManagement(this.$route.params.id, dataUpdate)
                if(res_update.status == 200 || res_update.status == 201){
                    this.$hideLoader();
                    this.$store.state.global_push_dialog = true;
                    this.setupAlertDialogPush(
                        true,
                        "Information Saved",
                        "Information successfully saved",
                        "text-h5 green--text text-center",
                        "/approver-management"
                    );
                }else{
                    this.$hideLoader();
                    this.setupAlertDialog(
                        true,
                        "Information Saved",
                        "ไม่สามารถบันทึกได้",
                        "text-h5 red--text text-center"
                    );
                    return;
                }

            },
            setupAlertDialog(status, title, message, text_color) {
                this.title = title;
                this.message = message;
                this.dialogAdd = status;
                this.text_color = text_color;
            },
            setupAlertDialogPush(status, title, message, text_color, link) {
                this.title = title;
                this.message = message;
                this.dialogAdd = status;
                this.text_color = text_color;
                this.link = link;
            },
            },
            async beforeCreate() {
                console.log("beforeCreate");
                this.$store.state.navMenu = true;
            },
        };
    </script>
    
    <style scoped>
    .center {
        text-align: center;
    }
    </style>
    